import Navbar from "./components/Navbar";
import Footer from "./components/Footer"; // 导入新的 Footer 组件
import React, { useEffect, useState } from "react";
import "./DeveloperPage.css";
import API_BASE from "./config";

function DeveloperPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const API_URL = fetch(`${API_BASE}/api/articles`)
      .then((res) => res.json())
      .then((data) => {
        setArticles(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("加载文章失败", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="developer-page">
      <Navbar currentPath="/developer" />

      {/* Hero Section */}
      <section className="section hero">
        <div className="container">
          <h1 className="hero-title">开发者</h1>
          <p className="hero-subtitle">关于我，以及「思考链条」背后的故事</p>
        </div>
      </section>

      {/* 个人履历 */}
      <section className="section light-gray-bg">
        <div className="container">
          <h2 className="section-title">个人履历</h2>
          <ul className="timeline">
            <li>
              <strong>2019-2023</strong> — 某大学 学生
            </li>
            <li>
              <strong>2023-2025</strong> — 某制造业公司 职员
            </li>
            <li>
              <strong>2025-至今</strong> — 独立开发者
            </li>
          </ul>
        </div>
      </section>

      <section className="section light-gray-bg">
        <div className="container">
          <h2 className="section-title">联系方式</h2>
          <ul className="contact-list">
            <li>
              <span className="contact-label">邮箱：</span>
              <a href="m1330_7vxrv2v5fm@aka.yeah.net" className="contact-link">
                m1330_7vxrv2v5fm@aka.yeah.net
              </a>
            </li>
            {/* <li>
              <span className="contact-label">微信：</span>
              <span className="contact-text">NULL</span>
            </li> */}
            <li>
              <span className="contact-label">B站：</span>
              <a
                href="https://space.bilibili.com/3537111714105843?spm_id_from=333.788.0.0"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                阿不思白
              </a>
            </li>
          </ul>
        </div>
      </section>
      {/* 分割线 */}
      <div className="section-divider"></div>

      {/* 关于思考链条 */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">关于「思考链条」的思考</h2>
          <p
            style={{
              lineHeight: "1.8",
              fontSize: "1.125rem",
              color: "#4b3621",
            }}
          >
            很多人，也许和我一样，总是陷入一些痛苦。
          </p>
          <p
            style={{
              lineHeight: "1.8",
              fontSize: "1.125rem",
              color: "#4b3621",
            }}
          >
            在互联网上由于一些事情冲浪，过了一段时间，事情没了，自己却只记得零零碎碎的片段。
            有时候，摸鱼刷手机，刷着刷着，感觉时间完全浪费掉了，心里有些自责。但不刷，又很想看。
            和一些网友，或是任何人争吵。吵着吵着，你发觉对方说的话毫无逻辑了，或者说，你们聊的不是一件事了，变成彼此发泄情绪。你却又不知怎么拉回正轨。
          </p>

          <p
            style={{
              lineHeight: "1.8",
              fontSize: "1.125rem",
              color: "#4b3621",
            }}
          >
            于是我选择开发了这款软件，你把自己的思考，有逻辑地记录下来（利用层级结构）。然后把它分享给对方。你让对方指正你的错误，如果ta说不出来了，你便知道无需多言，这次对话也就没必要继续下去了。如果对方合理指正，你也觉得有道理，那就记录下来，补充你的观点。
            我希望世界少些戾气，又多些友善真诚的沟通。
          </p>

          <p
            style={{
              lineHeight: "1.8",
              fontSize: "1.125rem",
              color: "#4b3621",
            }}
          >
            和朋友探讨过这番想法后，他向我提供了更多建议。我意识到这款软件能做的不止于此，它完全可以用来记录你与他人的沟通，以便日后翻看和回顾。同时，你也可以把它单纯用于记录和分享自己所爱。
            比如说，你把自助餐店记录下来，连带着你对于它的观感、它的地址……之后如果有人来问你自助餐推荐，你生成一下分享图，很轻松地发给对方图片就可以了。
            我会建立一些社群，也很欢迎你在群里交流自己的观点。汲取他人所长，分享自己的逻辑，我觉得都是超级有趣的事情。
            {/* 当我看到网上很多不休止的争论，但有时因表达方式有限，人们无法更好更完整地交流与互换意见。
            所以，我迫切希望有一款软件能改变这一局面。 */}
          </p>

          <p
            style={{
              lineHeight: "1.8",
              fontSize: "1.125rem",
              color: "#4b3621",
            }}
          >
            祝愿你在互联网冲浪愉快，也祝愿你收获自己想要的东西。请勿戾气，好好谈谈。请让我们聆听彼此。
            {/* 它只是一个小工具，并非社交平台。它用树状图的方式，方便梳理、扩充、分享你的思想。
            当然，本产品完全作为自身思想储藏室也是非常合适的。 */}
          </p>

          <p
            style={{
              lineHeight: "1.8",
              fontSize: "1.125rem",
              color: "#4b3621",
            }}
          >
            {/* 我希望有一天的互联网是这样的：请勿戾气，好好谈谈。请让我们聆听彼此。 */}
            或许，平平无奇的、碎片化的网络阅读时间，也能让你收获颇丰。
          </p>
        </div>
      </section>

      {/* 分割线 */}
      <div className="section-divider"></div>

      {/* 文章列表 */}
      <section className="section white-bg">
        <div className="container">
          <h2 className="section-title center-text">我的文章</h2>
          {loading ? (
            <p className="center-text">加载中...</p>
          ) : articles.length > 0 ? (
            <ul className="article-list">
              {articles.map((article) => (
                <li key={article.id} className="article-item">
                  {article.cover && (
                    <img
                      src={article.cover}
                      alt={article.title}
                      className="article-image"
                      loading="lazy"
                    />
                  )}
                  <a
                    href={article.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="article-title"
                  >
                    {article.title}
                  </a>
                  <div className="article-date">{article.date}</div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="center-text">暂无文章</p>
          )}
        </div>
      </section>
      {/* Footer */}
      {/* 使用共享的 Footer 组件 */}
      <Footer />
      {/* <footer className="footer">
        <div className="container">
          <p>
            &copy; {new Date().getFullYear()} 热茶满座. All Rights Reserved.
          </p>
        </div>
      </footer> */}
    </div>
  );
}

export default DeveloperPage;
